import { useEffect, useState } from "react";

import adminDriverApi from "modules/admin/drivers/store/api";
import { buildFirstLevelFilter as buildAdminDriverFilter } from "modules/admin/clients/helper";
import internalDriverApi from "modules/client/internal-drivers/store/api";
import { buildFirstLevelFilter as buildInternalDriverFilter } from "modules/client/internal-drivers/helper";

// Admins pick from active Flexio drivers plus the internal drivers of the route's client
// (clientId); clients pick from their own active internal drivers. Fetched locally (not via
// the redux driver slices) so we don't clobber the paginated lists on the Drivers pages.
const useAssignableDrivers = (isAdmin, enabled = true, clientId) => {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    const fetchDrivers = async () => {
      setLoading(true);
      try {
        const res = isAdmin
          ? await adminDriverApi.getDriverList({
              pageSize: 3000,
              filter: buildAdminDriverFilter({ active: true })
            })
          : await internalDriverApi.getDriverList({
              pageSize: 1000,
              filter: buildInternalDriverFilter({
                is_internal_driver: true,
                active: true
              })
            });
        let list = res?.data || [];
        if (isAdmin) {
          // Never offer one client's internal driver for another client's route.
          list = list.filter(
            (driver) =>
              !driver.isInternalDriver ||
              (clientId && (driver.clientIds || []).includes(clientId))
          );
        }
        if (!cancelled) setDrivers(list);
      } catch (err) {
        console.log(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchDrivers();
    return () => {
      cancelled = true;
    };
  }, [isAdmin, enabled, clientId]);

  return { drivers, loading };
};

export default useAssignableDrivers;
